module.exports = __webpack_public_path__ + "static/media/cylinder_cover_orange.c060a10d.png";